import React, { useMemo } from 'react';
import { Col, Row, Image } from 'react-bootstrap';
import { Button, InfoLabel } from '../../../../common/components';
import { InternalButtonBar } from '../../../layout/components';

import getIncludedResource from '../../../../helpers/getIncludedResource';

import './BrokerCommissionShow.scss';

const getOverride = (overrides, insurerId) => {
  return overrides && overrides[insurerId] ? overrides[insurerId] + '%' : '';
};

const TableHeader = () => (
  <div className={'broker-table'}>
    <Row>
      <Col xs={2}>
        <p>Brand</p>
      </Col>
      <Col xs={2}>
        <p>Active date</p>
      </Col>
      <Col xs={2}>
        <p>Brokerage</p>
      </Col>
      <Col xs={2}>
        <p>Override</p>
      </Col>
    </Row>
  </div>
);
const Label = ({ logo, name }) => {
  if (logo) {
    return <Image className={'insurer-logo'} fluid src={logo} alt={name} />;
  }
  return <span className={'insurer-logo'}>{name}</span>;
};

const sortCommissionsByProduct = (commissions, included) => {
  return commissions.reduce((carry, commission) => {
    const product = getIncludedResource(commission, included, 'product');
    if (!product.data?.attributes) {
      return carry;
    }

    const productName = product?.data.attributes.name;

    if (carry[productName]) {
      carry[productName].push(commission);
      return carry;
    }
    carry[productName] = [commission];
    return carry;
  }, {});
};
const ProductCommission = ({ commissions, included, totalCommissionOverride }) => {
  if (!commissions?.length) {
    return null;
  }

  return (
    <div>
      <TableHeader />
      {commissions.map((commission) => {
        const insurer = getIncludedResource(commission, included, 'insurer');

        const insurerAttributes = insurer?.data.attributes;

        return (
          <div className={'broker-table'} key={commission.id}>
            <Row>
              <Col sm={2}>
                <Label logo={insurerAttributes?.logo} name={insurerAttributes?.name} />
              </Col>
              <Col sm={2}>
                <InfoLabel date value={commission.attributes.from_date} />
              </Col>
              <Col sm={2}>
                <InfoLabel value={`${commission?.attributes.rate}%`} />
              </Col>
              <Col sm={2}>
                <InfoLabel
                  value={getOverride(totalCommissionOverride, insurer?.data.id)}
                />
              </Col>
            </Row>
          </div>
        );
      })}
    </div>
  );
};

const BrokerCommissionsShow = ({ resource, commissions }) => {
  const resourceAttributes = resource.data.attributes;

  const commissionsByProduct = useMemo(
    () => sortCommissionsByProduct(commissions, resource.included),
    [commissions, resource.included],
  );
  const productList = Object.keys(commissionsByProduct);
  return (
    <div className={'broker-commission-show'}>
      <>
        {commissions.length === 0 && <p>No active products</p>}
        {productList?.map((product) => {
          const productCommissions = commissionsByProduct[product];
          return (
            <div className={'product-commission-section'}>
              <h2 className={'product-title'}> {product}</h2>
              <ProductCommission
                commissions={productCommissions}
                included={resource.included}
                totalCommissionOverride={
                  resourceAttributes.total_commission_overrides ?? ''
                }
              />
            </div>
          );
        })}

        <Row>
          <Col sm={2}>
            <h4 className={'product-title'}>Admin Fee Tier</h4>
          </Col>
          <Col sm={3}>
            <InfoLabel value={resourceAttributes.admin_fee_tier} />
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['user.edit', 'broker.edit'],
                  button: (
                    <Button
                      link={true}
                      to={`/admin/brokers/${resource.data.id}/commissions/edit`}
                      className="pull-right"
                      label="Edit"
                      bsStyle="primary"
                      rightIcon="percent"
                    />
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </>
    </div>
  );
};

export default BrokerCommissionsShow;
